import {defineAsyncComponent} from 'vue';
import popupUtil from '@/commons/popupUtil.js';

const dvcFileDetail = defineAsyncComponent(() =>
  import('@/views/etreasury/dvcFile/DVCFileDetail.vue'),
);

const dvcVoucherTemplatePopup = defineAsyncComponent(() =>
  import('@/views/etreasury/dvcFile/DVCVoucherTemplatePopup.vue'),
);

const dvcLinkedFilePopup = defineAsyncComponent(() =>
  import('@/views/etreasury/dvcFile/DVCLinkedFilePopup.vue'),
);

const dvcSettingFileCodePopup = defineAsyncComponent(() =>
  import('@/views/etreasury/dvcFile/DVCSettingFileCodePopup.vue'),
);

// DVC form popups (mẫu chứng từ giao dịch với kho bạc)
const C402akb = defineAsyncComponent(() => import('@/views/etreasury/dvcFile/popup/C402akb.vue'));
const C402ckb = defineAsyncComponent(() => import('@/views/etreasury/dvcFile/popup/C402ckb.vue'));

// DVC param popups (form tham số trước khi xem/sửa mẫu chứng từ)
const DVCParamC402akb = defineAsyncComponent(() => import('@/views/etreasury/dvcFile/popup/DVCParamC402akb.vue'));
const DVCParamC402ckb = defineAsyncComponent(() => import('@/views/etreasury/dvcFile/popup/DVCParamC402ckb.vue'));

const chooseApproverPopup = defineAsyncComponent(() =>
  import('@/views/etreasury/dvcFile/ChooseApproverPopup.vue'),
);

export function registerEtreasury(app) {
  const registerConfig = {
    DVCFileDetail: dvcFileDetail,
    DVCVoucherTemplatePopup: dvcVoucherTemplatePopup,
    DVCLinkedFilePopup: dvcLinkedFilePopup,
    DVCSettingFileCodePopup: dvcSettingFileCodePopup,
    C402akb,
    C402ckb,
    DVCParamC402akb,
    DVCParamC402ckb,
    ChooseApproverPopup: chooseApproverPopup,
  };

  const keys = Object.keys(registerConfig);

  keys.filter(key => {
    app.component(key, registerConfig[key]);
  });

  popupUtil.registerPopup(keys, 'etreasury');
}
